// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Re13K","content":"styles_content__2Xv8-"};